module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Apricot"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e190",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _vm._v("Apricot\n          ")])])])]), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Prunus armeniaca ")])])]), _c('p', {
    staticClass: "underline"
  }, [_vm._v("In ancient Persia, the apricot was reverentially referred to as ")]), _c('p', {
    staticClass: "underline"
  }, [_vm._v("“the egg of the sun,” and in the Near East, where the ")]), _c('p', {
    staticClass: "underline"
  }, [_vm._v("apricot flourishes, it is respectfully called “the moon of the faithful.”\n          ")]), _c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("N")]), _vm._v("ortheastern China has been identified as this sunny,\n        sweet-fleshed fruit’s birthplace, most placing the date at about 1000 B.C. A "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Prunus")])]), _vm._v(" member of the greater rose family, the apricot\n        subsequently spread throughout Asia, ultimately wending its way into Armenia (thus "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("armeniaca")])]), _vm._v(") by about 300 B.C. Apricots, however, appear to\n        be a far-flung and generally unsociable family, as every region of every country in which\n        the apricot thrives seems to have its own signature cultivar and little selection seems to\n        have taken place anywhere within the apricot genus until the nineteenth century. ")]), _c('p', [_vm._v("The\n        word "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("apricock")])]), _vm._v(" first appeared in English print in\n        1551, deriving from the Latin "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("praecoquus,")])]), _vm._v(" also the\n        root for "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("precocious")])]), _vm._v(" and, in this case, meaning “early\n        ripening.” Symbolically, the apricot, along with the peach and other stone fruits, was an\n        ancient icon of female genitalia; in medieval France, for instance, the word "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("abricot")])]), _vm._v(" was a popular slang term for “vulva.” ")]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Blenheim Apricot."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Blenheim Apricot.",
      "src": "images/Apricot_Blenheim.jpg"
    }
  })]), _c('p', [_vm._v("It was\n        Franciscan missionaries who introduced the apricot to North America, and it was in the area\n        south of San Francisco in 1792 that the first major U.S. production of apricots was\n        recorded. Here, however, we come up against a somewhat cheerless truth: 95 percent of\n        U.S.–grown apricots still come from California. To lunge straight to the heart of it, the\n        apricot is a fruit plant with a tiresome propensity for swooning if the temperatures and\n        climatic conditions are not wholly agreeable. For instance, apricots are keen on lots of\n        moisture but not soggy feet, seem to prefer a cool, foggy summer and a damp, warm one\n        equally, and can be broadly subject to loss of bloom or fruit by spring frost, while at the\n        same moment requiring an adequately cold winter dormancy. “Difficult,” as one would refer to\n        a testy relative, I think about sums it up. ")]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Rival Apricot."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Rival Apricot.",
      "src": "images/Apricot_Rival.jpg"
    }
  }), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Apricot\n        ‘Rival’")])])]), _c('p', [_vm._v("Medicinally, apricot seeds were used to treat tumors in an\n        astonishingly early A.D. 502, and in Great Britain apricot oil was used as an erstwhile cure\n        for tumors and ulcers throughout the seventeenth century. Interestingly, the wildly\n        controversial drug Laetrile, ultimately disproved as a viable cancer therapy, was originally\n        derived from an extract of apricot seeds. Modern medicine, however, does confirm that\n        apricots are an excellent source of beta-carotene (one apricot will provide you with 10\n        percent of your daily recommended amount), vitamin C, iron, potassium, and fiber.\n        ")]), _c('p', [_vm._v("Apricots are truly lovely trees: small to medium-sized with a dense, spreading\n        canopy, glossy reddish-brown bark, pretty heart-shaped leaves, and positive flurries of\n        pretty white-to-pink "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Prunus")])]), _vm._v(" blossoms. Another\n        positive is that most U.S.–grown cultivars are self-fruitful, so you only need to plant one.\n        There are literally scores of apricot varieties, so if I haven’t managed to dissuade you\n        from attempting cultivation, it would pay to visit your local nursery and have them advise\n        you about the likeliest prospects for your zone and climate. Although it can take 4 years\n        for a young tree to begin fruiting, once established, a single tree can bear as much as 45\n        pounds of apricots a year for 20 years or more. Culturally, despite their need for regular\n        waterings, try to keep in mind the finicky apricot’s aversion to wet feet. Also, for optimal\n        fruit size and harvest, you may want to thin your fruits to every 2 to 4 inches per branch.\n        Our Viennese friends have historically plied us with mouthwatering apricot dumplings in\n        season, wrapped in phyllo dough parcels and drenched in butter with a sprinkling of sugar,\n        so here let me recommend that sumptuous recipe to you. Try to make two your limit.")]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Rival Apricot."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Rival Apricot.",
      "src": "images/Apricot_Rival2.jpg"
    }
  }), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Apricot ‘Rival’\n        pit")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0ea29b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch04.vue
// module id = 75
// module chunks = 0